import { useEffect } from 'react';
import { isEditableTarget } from './shortcutUtils.js';

export const useVarianceDrawerKeyboardShortcuts = ({
  accountResolverContext,
  canMarkComplete,
  handleMarkComplete,
  handleOpenAccountResolver,
  hasUnsavedVarianceActions,
  hasVarianceActions,
  isVarianceActionBusy,
  navigationBlocked = false,
  onNavigateNext,
  onNavigatePrevious,
  open,
  requestResetAllVarianceActions,
  safeClose,
  saveAllVarianceActions,
  setProductDetailContext,
  toggleFullscreen,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (isEditableTarget(event.target)) return;
      const key = event.key.toLowerCase();
      const navigatePrevious = key === 'p' || event.key === 'ArrowLeft' || event.key === 'ArrowUp';
      const navigateNext = key === 'n' || event.key === 'ArrowRight' || event.key === 'ArrowDown';

      if (!navigationBlocked && navigatePrevious && onNavigatePrevious) {
        event.preventDefault();
        onNavigatePrevious();
        return;
      }
      if (!navigationBlocked && navigateNext && onNavigateNext) {
        event.preventDefault();
        onNavigateNext();
        return;
      }
      if (key === 'f') {
        event.preventDefault();
        toggleFullscreen();
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        safeClose();
      }
      if (key === 'm' && canMarkComplete) {
        event.preventDefault();
        handleMarkComplete();
      }
      if (key === 'a' && accountResolverContext) {
        event.preventDefault();
        handleOpenAccountResolver();
      }
      if (key === 'd' && accountResolverContext) {
        event.preventDefault();
        setProductDetailContext(accountResolverContext);
      }
      if (key === 'r' && hasVarianceActions && !isVarianceActionBusy) {
        event.preventDefault();
        requestResetAllVarianceActions();
      }
      if ((event.metaKey || event.ctrlKey) && key === 's' && hasUnsavedVarianceActions && !isVarianceActionBusy) {
        event.preventDefault();
        saveAllVarianceActions();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [
    accountResolverContext,
    canMarkComplete,
    handleMarkComplete,
    handleOpenAccountResolver,
    hasUnsavedVarianceActions,
    hasVarianceActions,
    isVarianceActionBusy,
    navigationBlocked,
    onNavigateNext,
    onNavigatePrevious,
    open,
    requestResetAllVarianceActions,
    safeClose,
    saveAllVarianceActions,
    setProductDetailContext,
    toggleFullscreen,
  ]);
};
